import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#000000", contrastText: "#ffffff" },
    secondary: { main: "#ffffff", contrastText: "#000000" },
    error: { main: "#dc2626" },
    background: { default: "#ffffff", paper: "#f5f5f5" },
    text: { primary: "#111111", secondary: "#737373" },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
    button: {
      textTransform: "uppercase",
      letterSpacing: "0.08em",
      fontWeight: 600,
    },
  },
  shape: { borderRadius: 0 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { boxShadow: "none", "&:hover": { boxShadow: "none" } },
      },
    },
    MuiCard: {
      styleOverrides: { root: { boxShadow: "none" } },
    },
    MuiAppBar: {
      styleOverrides: { root: { boxShadow: "none" } },
    },
    MuiSelect: {
      styleOverrides: { root: { borderRadius: 0 } },
    },
  },
});

export default theme;
